import typedApiRequestService from 'common/services/api/typedApiRequestService/typedApiRequestService';
import { Method } from 'common/services/http/types';

import getSurveyDataScheme from './shemes/getSurveyDataScheme';

const getSurveyDataService = () =>
  typedApiRequestService({
    method: '/surveys/active',
    httpMethod: Method.Get,
    validationScheme: getSurveyDataScheme,
  });

export default getSurveyDataService;
